import { TypeScriptUtils } from '../../utils';
import { ClassFeatureSimulators } from '../ClassFeature';
import { DefinitionPoolUtils } from '../DefinitionPool';
import { HelperUtils } from '../Helper';
import { getDefinitionKey } from './accessors';
/**
 *
 * @param optionalClassFeatureMappings
 * @param definitionPool
 */
export function generateOptionalClassFeatures(optionalClassFeatureMappings, definitionPool, classes) {
    return optionalClassFeatureMappings
        .map((mapping) => generateOptionalClassFeature(mapping, definitionPool, classes))
        .filter(TypeScriptUtils.isNotNullOrUndefined);
}
/**
 *
 * @param optionalClassFeatureMapping
 * @param definitionPool
 */
export function generateOptionalClassFeature(optionalClassFeatureMapping, definitionPool, classes) {
    const definitionKey = getDefinitionKey(optionalClassFeatureMapping);
    if (definitionKey === null) {
        return null;
    }
    return Object.assign(Object.assign({}, optionalClassFeatureMapping), { classFeature: ClassFeatureSimulators.simulateClassFeature(definitionKey, definitionPool, classes), accessType: DefinitionPoolUtils.getDefinitionAccessType(definitionKey, definitionPool) });
}
/**
 *
 * @param optionalClassFeatures
 */
export function generateOptionalClassFeatureLookup(optionalClassFeatures) {
    return HelperUtils.generateNonNullLookup(optionalClassFeatures, getDefinitionKey);
}
